/* Alternativen fuer ausverkaufte Produkte (snippets/product-alternatives.liquid) */

if (!customElements.get('product-alternatives')) {
  // Fahrzeuge (IDs) eines Produkts anhand seiner Tags, ueber die gemeinsame Fahrzeug-Registry der Garage
  const vehicleIds = (tags) => new Set(window.BGGarage ? window.BGGarage.vehiclesFor(tags).map((v) => v.id) : []);

  const formatPrice = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  class ProductAlternatives extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.ownVehicles = vehicleIds((this.dataset.tags || '').split('|'));
      this.list = this.querySelector('[data-alt-list]');
      this.hint = this.querySelector('[data-alt-hint]');
      this.load();
    }

    async load() {
      try {
        const res = await fetch(`/recommendations/products.json?product_id=${this.productId}&limit=12&intent=related`);
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        this.render(data.products || []);
      } catch (e) {
        this.hidden = true;
      }
    }

    score(product, vehicle) {
      const tags = product.tags || [];
      if (vehicle && window.BGGarage.fits(tags, vehicle)) return 2;
      const others = vehicleIds(tags);
      return [...others].some((id) => this.ownVehicles.has(id)) ? 1 : 0;
    }

    render(products) {
      const vehicle = window.BGGarage ? window.BGGarage.get() : null;
      const items = products
        .filter((p) => p.available && String(p.id) !== String(this.productId))
        .map((p, index) => ({ p, index, score: this.score(p, vehicle) }))
        .sort((a, b) => b.score - a.score || a.index - b.index)
        .slice(0, MAX_ITEMS);

      if (!items.length) {
        this.hidden = true;
        return;
      }

      const anyFit = vehicle && items.some((item) => item.score === 2);
      if (this.hint) this.hint.hidden = !anyFit;

      this.list.innerHTML = '';
      items.forEach(({ p, score }) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'alternatives__item';
        a.href = p.url;

        if (p.featured_image) {
          const img = document.createElement('img');
          img.className = 'alternatives__img';
          img.src = `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=160`;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 72;
          img.height = 72;
          a.append(img);
        }

        const text = document.createElement('span');
        text.className = 'alternatives__text';
        const title = document.createElement('span');
        title.className = 'alternatives__name';
        title.textContent = p.title;
        const price = document.createElement('span');
        price.className = 'alternatives__price';
        price.textContent = p.price_varies ? `ab ${formatPrice(p.price_min)}` : formatPrice(p.price);
        text.append(title, price);

        if (vehicle && score === 2) {
          const fit = document.createElement('span');
          fit.className = 'alternatives__fit';
          fit.textContent = '✓ Passt für dein Fahrzeug';
          text.append(fit);
        }

        a.append(text);
        li.append(a);
        this.list.append(li);
      });

      this.hidden = false;
    }
  }

  customElements.define('product-alternatives', ProductAlternatives);
}
